import { useQuery } from "@apollo/client";
import { Card, List, Row, Col, Badge, Button, Descriptions, Tag, Divider, Empty } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";

import { SUBGRAPHS_QUERY } from "../../helpers/graphql/subgraph";
import { SubgraphOriginMetrics } from "../../components/subgraph/SubgraphOriginMetrics";
import { SubgraphMetrics } from "../../components/subgraph/SubgraphMetrics";
import { networkColorList } from "../../helpers/network.color";

const InitialState = {
  id: "",
  network: "",
  createdAt: "",
  indexingStatus: {
    entityCount: "",
    chains: [],
  },
};

export function SubgraphInfo({ project }: any) {
  const [subgraph, setSubgraph] = useState(InitialState);

  const { loading: loadingSubgraph, data: dataSubgraphs } = useQuery(SUBGRAPHS_QUERY, {
    variables: { projectId: project.id, cluster: "v1" },
  });

  const subgraphs = dataSubgraphs?.subgraphs;

  useEffect(() => {
    if (subgraphs?.length > 0) {
      setSubgraph(subgraphs[0]);
    }
  }, [subgraphs]);

  const chainData =
    subgraph.indexingStatus?.chains.length > 0 ? subgraph.indexingStatus?.chains[0] : (null as any);
  const networkColor =
    chainData?.network !== undefined ? networkColorList[chainData?.network] : "grey";

  function renderSubgraphList() {
    return (
      <List
        style={{ height: "25vh", overflow: "scroll" }}
        dataSource={subgraphs}
        renderItem={(item: any) => {
          const status =
            item.indexingStatus?.health === "healthy"
              ? "success"
              : item.indexingStatus?.health
              ? "error"
              : "warning";
          const borderColor = subgraph.id === item.id ? "#1890ff" : "#fff";

          return (
            <List.Item key={item.name} onClick={() => setSubgraph(item)}>
              <Button
                type="text"
                style={{
                  flex: 1,
                  textAlign: "start",
                  borderColor,
                }}
              >
                <Row>
                  <Col span={12} style={{ overflow: "auto" }}>
                    {item.name}
                  </Col>
                  <Col span={2}>
                    <Badge status={status} />
                  </Col>
                  <Col span={10}>{item.indexingStatus?.health || "not deployed"}</Col>
                </Row>
              </Button>
            </List.Item>
          );
        }}
      />
    );
  }

  return (
    <Row gutter={8}>
      <Col md={7} sm={24}>
        <Card className="card-body" title="Subgraph" extra={`Total ${subgraphs?.length || 0}`}>
          {!loadingSubgraph && subgraphs?.length > 0 ? (
            <>
              <Descriptions column={{ xl: 2, lg: 1, md: 1, sm: 2, xs: 1 }} size="small">
                <Descriptions.Item>{subgraph.id}</Descriptions.Item>
                <Descriptions.Item label="Network">
                  <Tag color={networkColor}>{chainData?.network || "N/A"}</Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Data count">
                  {subgraph?.indexingStatus?.entityCount || 0}
                </Descriptions.Item>
                <Descriptions.Item label="Created">
                  {subgraph.createdAt !== "" ? moment(subgraph.createdAt).fromNow() : "-"}
                </Descriptions.Item>
              </Descriptions>
              <Divider />
              {subgraphs ? renderSubgraphList() : null}
            </>
          ) : (
            <Empty />
          )}
        </Card>
      </Col>
      <Col md={17} sm={24}>
        <Row gutter={8}>
          <Col lg={12} md={24}>
            {subgraph ? <SubgraphMetrics cluster={'v1'} subgraphId={subgraph.id} height={340} /> : <Empty />}
          </Col>
          <Col lg={12} md={24}>
            {subgraph ? <SubgraphOriginMetrics cluster={'v1'} subgraphId={subgraph.id} height={340} /> : <Empty />}
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
